import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68954198&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68954198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68954198')) {
      api.createRecord('68954198', component.options)
    } else {
      api.reload('68954198', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68954198&scoped=true", function () {
      api.rerender('68954198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/limit/index.vue"
export default component.exports